// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".current_resource{animation:twinkling 1s ease-in-out .3s infinite alternate;width:60px;height:15px;background-color:#f54236;float:left;margin-right:5px;cursor:auto}.download-button{float:left;margin-right:20px;margin-top:-2px}@keyframes twinkling{0%{opacity:.3}to{opacity:1}}.download-svg-css{width:1280px;height:768px;z-index:-1;position:absolute;top:50px}", ""]);
// Exports
module.exports = exports;
